import type { BadgeProps } from '@printdeal/ui-library';
import { klona } from 'klona/lite';
import { defineMessages, MessageDescriptor } from 'react-intl';

const baseMessages = defineMessages({
  docreviewrejected: {
    id: 'account.order.lineitem.state.docreviewrejected',
    defaultMessage: 'Artwork rejected',
  },
  cancelled: {
    id: 'account.order.lineitem.state.cancelled',
    defaultMessage: 'Cancelled',
  },
  waitingfordocreview: {
    id: 'account.order.lineitem.state.waitingfordocreview',
    defaultMessage: 'In progress',
  },
  waitingforsecondarydocreview: {
    id: 'account.order.lineitem.state.waitingforsecondarydocreview',
    defaultMessage: 'In progress',
  },
  docfeedbackrequested: {
    id: 'account.order.lineitem.state.docfeedbackrequested',
    defaultMessage: 'In progress',
  },
  docreviewinproofing: {
    id: 'account.order.lineitem.state.docreviewproofing',
    defaultMessage: 'In progress',
  },
  waitingforproposal: {
    id: 'account.order.lineitem.state.waitingforproposal',
    defaultMessage: 'In progress',
  },
  docreviewinprogress: {
    id: 'account.order.lineitem.state.docreviewinprogress',
    defaultMessage: 'In progress',
  },
  docreviewapproved: {
    id: 'account.order.lineitem.state.docreviewapproved',
    defaultMessage: 'In progress',
  },
  readyforfulfillment: {
    id: 'account.order.lineitem.state.readyforfulfillment',
    defaultMessage: 'In progress',
  },
  docreviewfailed: {
    id: 'account.order.lineitem.state.docreviewfailed',
    defaultMessage: 'In progress',
  },
  processingcloudlabartwork: {
    id: 'account.order.lineitem.state.processingcloudlabartwork',
    defaultMessage: 'In progress',
  },
  processingcloudlabartworkfailed: {
    id: 'account.order.lineitem.state.processingcloudlabartworkfailed',
    defaultMessage: 'In progress',
  },
  senttomcp: {
    id: 'account.order.lineitem.state.senttomcp',
    defaultMessage: 'In production',
  },
  fulfillmentrejected: {
    id: 'account.order.lineitem.state.fulfillmentrejected',
    defaultMessage: 'In production',
  },
  fulfillmenterror: {
    id: 'account.order.lineitem.state.fulfillmenterror',
    defaultMessage: 'In production',
  },
  fulfillmentaccepted: {
    id: 'account.order.lineitem.state.fulfillmentaccepted',
    defaultMessage: 'In production',
  },
  printinginprogress: {
    id: 'account.order.lineitem.state.printinginprogress',
    defaultMessage: 'In production',
  },
  shipped: {
    id: 'account.order.lineitem.state.shipped',
    defaultMessage: 'Shipped',
  },
  initial: {
    id: 'account.order.lineitem.state.initial',
    defaultMessage: 'Processing',
  },
  confirmed: {
    id: 'account.order.lineitem.state.confirmed',
    defaultMessage: 'Processing',
  },
  processing: {
    id: 'account.order.lineitem.state.processing',
    defaultMessage: 'Processing',
  },
  waitingforartwork: {
    id: 'account.order.lineitem.state.waitingforartwork',
    defaultMessage: 'Waiting for artwork',
  },
  held: {
    id: 'account.order.lineitem.state.held',
    defaultMessage: 'Processing',
  },
  editinprogress: {
    id: 'account.order.lineitem.state.editinprogress',
    defaultMessage: 'Edit in progress',
  },
  unknown: {
    id: 'account.order.lineitem.state.unknown',
    defaultMessage: 'Unknown',
  },
});

interface ExtendedMessage extends MessageDescriptor {
  color?: BadgeProps['variant'];
}

/**
 * Extra data cannot be added to the object inside defineMessages,
 * because it is a hook to "scrape" the default messages from the component.
 * https://stackoverflow.com/questions/39811438/why-does-definemessages-from-react-intl-throw-an-error-when-passing-in-a-object
 */
export const messages = klona(baseMessages) as Record<string, ExtendedMessage>;
messages.docreviewrejected.color = 'error';
messages.cancelled.color = 'dim';
messages.waitingfordocreview.color = 'info';
messages.waitingforsecondarydocreview.color = 'info';
messages.waitingforproposal.color = 'info';
messages.docfeedbackrequested.color = 'info';
messages.docreviewinproofing.color = 'primary';
messages.docreviewinprogress.color = 'info';
messages.docreviewapproved.color = 'info';
messages.readyforfulfillment.color = 'info';
messages.docreviewfailed.color = 'info';
messages.senttomcp.color = 'info';
messages.fulfillmentrejected.color = 'info';
messages.fulfillmenterror.color = 'info';
messages.fulfillmentaccepted.color = 'info';
messages.printinginprogress.color = 'info';
messages.shipped.color = 'success';
messages.initial.color = 'primary';
messages.confirmed.color = 'primary';
messages.processing.color = 'primary';
messages.editinprogress.color = 'primary';
messages.waitingforartwork.color = 'primary';
messages.held.color = 'info';
messages.unknown.color = 'dim';
